/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

	/*
	A little info for this js file:

	As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
		As mentioned below, most code added to this file should be included within the "on load" function.

	For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
		including any relavant details regarding what the code overrides, etc.
	*/


(function(){
	'use strict';

	/**
	 * Store the visitor's current-session page journey and pass it to Freeform's
	 * User Path field. Query strings and hashes are intentionally excluded.
	 */
	var userPathStorageKey = 'eosys-user-path';
	var userPathLimit = 20;
	var fallbackUserPath = [];

	function getStoredUserPath() {
		try {
			var storedValue = window.sessionStorage.getItem(userPathStorageKey);
			var storedPath = storedValue ? JSON.parse(storedValue) : [];

			if (Array.isArray(storedPath)) {
				return storedPath.filter(function(path) {
					return typeof path === 'string' && path.length > 0;
				}).slice(-userPathLimit);
			}
		} catch (error) {
			// sessionStorage can be unavailable in privacy-restricted browsers.
		}

		return fallbackUserPath.slice(-userPathLimit);
	}

	function storeUserPath(userPath) {
		fallbackUserPath = userPath.slice(-userPathLimit);

		try {
			window.sessionStorage.setItem(
				userPathStorageKey,
				JSON.stringify(fallbackUserPath)
			);
		} catch (error) {
			// Keep the in-memory fallback when sessionStorage is unavailable.
		}
	}

	function getCurrentPagePath() {
		var pagePath = window.location.pathname || '/';

		// Keep the root slash, but normalize trailing slashes on all other paths.
		if (pagePath.length > 1) {
			pagePath = pagePath.replace(/\/+$/, '');
		}

		return pagePath || '/';
	}

	function recordCurrentPagePath() {
		var userPath = getStoredUserPath();
		var currentPagePath = getCurrentPagePath();

		// Avoid duplicate entries caused by reloads or the initial pageshow event.
		if (userPath[userPath.length - 1] !== currentPagePath) {
			userPath.push(currentPagePath);
		}

		storeUserPath(userPath.slice(-userPathLimit));
	}

	function populateUserPathFields() {
		var userPathValue = getStoredUserPath().join(' > ');
		var userPathFields = document.querySelectorAll('#user-path');

		for (var i = 0; i < userPathFields.length; i++) {
			userPathFields[i].value = userPathValue;
		}
	}

	recordCurrentPagePath();

	window.addEventListener('pageshow', function() {
		recordCurrentPagePath();
		populateUserPathFields();
	});

	document.addEventListener('DOMContentLoaded', populateUserPathFields);

	// Refresh the value immediately before Freeform or the browser handles it.
	document.addEventListener('submit', function(event) {
		if (event.target && event.target.querySelector('#user-path')) {
			populateUserPathFields();
		}
	}, true);

	/**
	 * Gate selected downloads from any component, while retaining the Cards
	 * layout's opt-in gated-content behavior.
	 */
	var globallyGatedDownloads = {
		'/uploads/ai-readiness-guide.pdf': 'AI Readiness Guide'
	};
	var gatedContentCookieName = 'gatedContentUnlocked';
	var gatedContentUnlockDays = 365;

	function applyModalButtonClasses(container) {
		if (!container) {
			return;
		}

		var submitButtons = container.querySelectorAll('button[type="submit"]');

		for (var i = 0; i < submitButtons.length; i++) {
			submitButtons[i].classList.add('button');
		}
	}

	function initGatedContent() {
		var modal = document.querySelector('[data-gated-content-modal]');

		if (!modal || modal.getAttribute('data-gated-content-initialized') === 'true') {
			return;
		}

		modal.setAttribute('data-gated-content-initialized', 'true');

		var closeButton = modal.querySelector('[data-gated-content-close]');
		var gatedContentPanel = modal.querySelector('[data-form-modal-panel="gated-content"]');
		var dynamicFormPanel = modal.querySelector('[data-form-modal-panel="dynamic-form"]');
		var form = gatedContentPanel ? gatedContentPanel.querySelector('.freeform-form') : null;
		var isUnlocked = getCookie(gatedContentCookieName) === '1';
		var pendingDownload = null;
		var triggerElement = null;

		applyModalButtonClasses(gatedContentPanel);

		function getCookie(name) {
			var escapedName = name.replace(/([$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1');
			var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));

			return match ? decodeURIComponent(match[1]) : null;
		}

		function setCookie(name, value, days) {
			var expires = '';
			var secure = window.location.protocol === 'https:' ? '; Secure' : '';

			if (typeof days === 'number') {
				var date = new Date();
				date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
				expires = '; expires=' + date.toUTCString();
			}

			document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax' + secure;
		}

		function getLinkText(link) {
			var linkCopy = link.cloneNode(true);
			var assistiveElements = linkCopy.querySelectorAll('.assistive');

			for (var i = 0; i < assistiveElements.length; i++) {
				assistiveElements[i].parentNode.removeChild(assistiveElements[i]);
			}

			return linkCopy.textContent ? linkCopy.textContent.trim() : '';
		}

		function getDownloadData(eventTarget) {
			if (!eventTarget || !eventTarget.closest) {
				return null;
			}

			var card = eventTarget.closest('.cards__item.linkclicker');
			var link = eventTarget.closest('a[href]');

			if (!link && card) {
				link = card.querySelector('.cards__item--link');
			}

			if (!link) {
				return null;
			}

			var parsedUrl;
			try {
				parsedUrl = new URL(link.href, window.location.href);
			} catch (error) {
				return null;
			}

			var globalTitle = globallyGatedDownloads[parsedUrl.pathname];
			var containingCard = card || link.closest('.cards__item');
			var isGatedCard = containingCard && containingCard.closest('[data-gated-content]');

			if (typeof globalTitle === 'undefined' && !isGatedCard) {
				return null;
			}

			var heading = containingCard ? containingCard.querySelector('.cards__item--heading') : null;
			var linkText = getLinkText(link);

			return {
				url: parsedUrl.href,
				title: globalTitle || link.getAttribute('data-download-title') || (heading ? heading.textContent.trim() : '') || linkText || document.title,
				linkText: linkText
			};
		}

		function setFieldValue(wrapperSelector, value) {
			var wrapper = modal.querySelector(wrapperSelector);

			if (!wrapper) {
				return;
			}

			var field = wrapper.querySelector('input, textarea, select');

			if (!field) {
				return;
			}

			field.value = value || '';
			field.dispatchEvent(new Event('input', { bubbles: true }));
			field.dispatchEvent(new Event('change', { bubbles: true }));
		}

		function populateDownloadFields(download) {
			setFieldValue('.download-url', download.url);
			setFieldValue('.download-title', download.title);
		}

		function trackDownload(download) {
			if (!download || !Array.isArray(window.dataLayer)) {
				return;
			}

			window.dataLayer.push({
				event: 'download_click',
				download_url: download.url,
				download_title: download.title || '',
				link_text: download.linkText || ''
			});
		}

		function openModal() {
			if (gatedContentPanel) {
				gatedContentPanel.hidden = false;
			}

			if (dynamicFormPanel) {
				dynamicFormPanel.hidden = true;
			}

			modal.setAttribute('aria-label', 'Download form');
			modal.removeAttribute('aria-labelledby');
			modal.hidden = false;
			modal.classList.add('active');
			modal.setAttribute('aria-hidden', 'false');
			document.body.classList.add('modal-open');

			window.requestAnimationFrame(function() {
				var firstField = modal.querySelector(
					'input:not([type="hidden"]):not([aria-hidden="true"]):not([tabindex="-1"]), select:not([aria-hidden="true"]):not([tabindex="-1"]), textarea:not([aria-hidden="true"]):not([tabindex="-1"]), button:not([aria-hidden="true"]):not([tabindex="-1"])'
				);

				if (firstField) {
					firstField.focus();
				}
			});
		}

		function closeModal(restoreFocus) {
			modal.classList.remove('active');
			modal.setAttribute('aria-hidden', 'true');
			document.body.classList.remove('modal-open');

			if (restoreFocus && triggerElement) {
				triggerElement.focus();
			}

			if (restoreFocus) {
				pendingDownload = null;
				triggerElement = null;
			}
		}

		function unlock() {
			var download = pendingDownload;

			isUnlocked = true;
			setCookie(gatedContentCookieName, '1', gatedContentUnlockDays);
			closeModal(false);
			pendingDownload = null;
			triggerElement = null;

			if (download) {
				trackDownload(download);

				var downloadWindow = window.open(download.url, '_blank');
				if (downloadWindow) {
					downloadWindow.opener = null;
				} else {
					window.location.assign(download.url);
				}
			}
		}

		document.addEventListener('click', function(event) {
			var download = getDownloadData(event.target);

			if (!download) {
				return;
			}

			if (isUnlocked) {
				trackDownload(download);
				return;
			}

			event.preventDefault();
			event.stopPropagation();
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			}

			pendingDownload = download;
			triggerElement = event.target.closest('a[href]') || event.target.closest('.cards__item.linkclicker');
			populateDownloadFields(download);
			openModal();
		}, true);

		if (closeButton) {
			closeButton.addEventListener('click', function() {
				closeModal(true);
			});
		}

		modal.addEventListener('click', function(event) {
			if (event.target === modal) {
				closeModal(true);
			}
		});

		document.addEventListener('keydown', function(event) {
			if (event.key === 'Escape' && modal.classList.contains('active')) {
				closeModal(true);
			}
		});

		if (form) {
			form.addEventListener('freeform-ajax-success', unlock);
		}
	}

	/**
	 * Lazy-load any Freeform selected by a modal CTA. Loaded forms and their
	 * dependencies are cached for the rest of the page session.
	 */
	function initDynamicFormModal() {
		var triggers = document.querySelectorAll('[data-modal-form-trigger]');
		var modal = document.querySelector('[data-gated-content-modal]');

		if (!triggers.length || !modal || modal.getAttribute('data-dynamic-form-initialized') === 'true') {
			return;
		}

		modal.setAttribute('data-dynamic-form-initialized', 'true');

		var gatedContentPanel = modal.querySelector('[data-form-modal-panel="gated-content"]');
		var dynamicFormPanel = modal.querySelector('[data-form-modal-panel="dynamic-form"]');
		var container = modal.querySelector('[data-modal-form-container]');
		var closeButton = modal.querySelector('[data-form-modal-close]');
		var formPanels = {};
		var loadPromises = {};
		var activeFormKey = null;
		var activeModalTitle = null;
		var restoreFocusTo = null;

		if (!dynamicFormPanel || !container) {
			return;
		}

		function absoluteUrl(url) {
			return new URL(url, window.location.href).href;
		}

		function stylesheetExists(url) {
			var stylesheets = document.querySelectorAll('link[rel="stylesheet"][href]');

			for (var i = 0; i < stylesheets.length; i++) {
				if (absoluteUrl(stylesheets[i].href) === url) {
					return true;
				}
			}

			return false;
		}

		function scriptExists(url) {
			var scripts = document.querySelectorAll('script[src]');

			for (var i = 0; i < scripts.length; i++) {
				if (absoluteUrl(scripts[i].src) === url) {
					return true;
				}
			}

			return false;
		}

		function loadStyles(sourceDocument) {
			var stylesheets = sourceDocument.querySelectorAll('link[rel="stylesheet"][href]');

			for (var i = 0; i < stylesheets.length; i++) {
				var url = absoluteUrl(stylesheets[i].getAttribute('href'));

				if (stylesheetExists(url)) {
					continue;
				}

				var link = document.createElement('link');
				link.rel = 'stylesheet';
				link.href = url;
				document.head.appendChild(link);
			}
		}

		function loadScript(sourceScript) {
			var url = absoluteUrl(sourceScript.getAttribute('src'));

			if (scriptExists(url)) {
				return Promise.resolve();
			}

			return new Promise(function(resolve, reject) {
				var script = document.createElement('script');
				script.src = url;
				script.async = false;
				script.onload = resolve;
				script.onerror = reject;
				document.body.appendChild(script);
			});
		}

		function loadScripts(sourceDocument) {
			var sourceScripts = Array.prototype.slice.call(
				sourceDocument.querySelectorAll('script[src]')
			);

			// Freeform scans the DOM when its core script runs. Load formatting and
			// spam-check handlers first when the core bundle is not already present.
			sourceScripts.sort(function(a, b) {
				var aIsCore = a.src.indexOf('/front-end/plugin/freeform.js') !== -1;
				var bIsCore = b.src.indexOf('/front-end/plugin/freeform.js') !== -1;

				return aIsCore === bIsCore ? 0 : (aIsCore ? 1 : -1);
			});

			return sourceScripts.reduce(function(promise, sourceScript) {
				return promise.then(function() {
					return loadScript(sourceScript);
				});
			}, Promise.resolve());
		}

		function namespaceFormIds(fragment, formKey) {
			var fieldsWithIds = fragment.querySelectorAll('form [id]');
			var idMap = {};
			var referenceAttributes = ['for', 'aria-controls', 'aria-describedby', 'aria-labelledby', 'list'];
			var idPrefix = 'modal-form-' + formKey.replace(/[^a-zA-Z0-9_-]/g, '-') + '-';

			for (var i = 0; i < fieldsWithIds.length; i++) {
				var oldId = fieldsWithIds[i].id;
				var newId = idPrefix + oldId;

				idMap[oldId] = newId;
				fieldsWithIds[i].id = newId;
			}

			for (var j = 0; j < referenceAttributes.length; j++) {
				var attribute = referenceAttributes[j];
				var referencedElements = fragment.querySelectorAll('form [' + attribute + ']');

				for (var k = 0; k < referencedElements.length; k++) {
					var references = referencedElements[k].getAttribute(attribute).split(/\s+/);
					var namespacedReferences = references.map(function(reference) {
						return idMap[reference] || reference;
					});

					referencedElements[k].setAttribute(attribute, namespacedReferences.join(' '));
				}
			}
		}

		function focusForm(formPanel) {
			window.requestAnimationFrame(function() {
				var firstField = formPanel.querySelector(
					'input:not([type="hidden"]):not([aria-hidden="true"]):not([tabindex="-1"]), select:not([aria-hidden="true"]):not([tabindex="-1"]), textarea:not([aria-hidden="true"]):not([tabindex="-1"]), button:not([aria-hidden="true"]):not([tabindex="-1"])'
				);

				if (firstField) {
					firstField.focus();
				}
			});
		}

		function getFormKey(trigger) {
			return trigger.getAttribute('data-form-id') || trigger.getAttribute('data-form-handle') || '';
		}

		function setStatus(message, isError) {
			var existingStatus = container.querySelector('[data-modal-form-status]');

			if (existingStatus) {
				existingStatus.parentNode.removeChild(existingStatus);
			}

			if (!message) {
				return;
			}

			var status = document.createElement('div');
			status.setAttribute('data-modal-form-status', '');
			status.innerHTML = isError
				? '<p role="alert">The form could not be loaded. Please try again.</p><button type="button" class="button" data-modal-form-retry>Try again</button>'
				: '<p>Loading form&hellip;</p>';
			container.appendChild(status);
		}

		function showFormPanel(formKey) {
			for (var key in formPanels) {
				if (Object.prototype.hasOwnProperty.call(formPanels, key)) {
					formPanels[key].hidden = key !== formKey;
				}
			}
		}

		function loadModalForm(formKey) {
			if (formPanels[formKey]) {
				return Promise.resolve(formPanels[formKey]);
			}

			if (loadPromises[formKey]) {
				return loadPromises[formKey];
			}

			setStatus('loading');

			loadPromises[formKey] = fetch('/modal-form?form=' + encodeURIComponent(formKey), {
				credentials: 'same-origin',
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				}
			}).then(function(response) {
				if (!response.ok) {
					throw new Error('Modal form request failed with status ' + response.status);
				}

				return response.text();
			}).then(function(html) {
				var sourceDocument = new DOMParser().parseFromString(html, 'text/html');
				var fragment = sourceDocument.querySelector('[data-modal-form-fragment]');

				if (!fragment) {
					throw new Error('Modal form response did not contain a form fragment');
				}

				loadStyles(sourceDocument);
				namespaceFormIds(fragment, formKey);

				var formPanel = document.createElement('div');
				formPanel.setAttribute('data-loaded-modal-form', formKey);
				formPanel.innerHTML = fragment.innerHTML;
				formPanel.hidden = true;
				container.appendChild(formPanel);
				formPanels[formKey] = formPanel;

				var formTitle = formPanel.querySelector('[data-modal-form-title]');
				if (formTitle) {
					formTitle.setAttribute('data-default-modal-title', formTitle.textContent);
				}

				applyModalButtonClasses(formPanel);
				setStatus('');

				return loadScripts(sourceDocument).then(function() {
					return formPanel;
				});
			}).catch(function(error) {
				delete loadPromises[formKey];
				setStatus('error', true);
				console.error(error);
				throw error;
			});

			return loadPromises[formKey];
		}

		function openDynamicFormModal(trigger) {
			var formKey = getFormKey(trigger);

			if (!formKey) {
				return;
			}

			activeFormKey = formKey;
			activeModalTitle = trigger.getAttribute('data-modal-title');
			restoreFocusTo = trigger;

			if (gatedContentPanel) {
				gatedContentPanel.hidden = true;
			}

			dynamicFormPanel.hidden = false;
			showFormPanel(formKey);
			modal.setAttribute('aria-label', trigger.getAttribute('data-modal-label') || 'Form');
			modal.removeAttribute('aria-labelledby');
			modal.hidden = false;
			modal.classList.add('active');
			modal.setAttribute('aria-hidden', 'false');
			document.body.classList.add('modal-open');

			loadModalForm(formKey).then(function(formPanel) {
				if (activeFormKey !== formKey) {
					return;
				}

				showFormPanel(formKey);

				var title = formPanel.querySelector('[data-modal-form-title]');
				if (title) {
					title.textContent = activeModalTitle || title.getAttribute('data-default-modal-title');
				}

				modal.removeAttribute('aria-label');
				if (title && title.id) {
					modal.setAttribute('aria-labelledby', title.id);
				}
				focusForm(formPanel);
			}).catch(function() {
				var retryButton = container.querySelector('[data-modal-form-retry]');
				if (retryButton) {
					retryButton.focus();
				}
			});
		}

		function closeDynamicFormModal() {
			if (dynamicFormPanel.hidden) {
				return;
			}

			modal.classList.remove('active');
			modal.setAttribute('aria-hidden', 'true');
			document.body.classList.remove('modal-open');
			activeFormKey = null;
			activeModalTitle = null;

			if (restoreFocusTo) {
				restoreFocusTo.focus();
				restoreFocusTo = null;
			}
		}

		for (var i = 0; i < triggers.length; i++) {
			triggers[i].addEventListener('click', function(event) {
				event.preventDefault();
				openDynamicFormModal(this);
			});
		}

		if (closeButton) {
			closeButton.addEventListener('click', closeDynamicFormModal);
		}

		modal.addEventListener('click', function(event) {
			if (event.target === modal) {
				closeDynamicFormModal();
			}
		});

		document.addEventListener('keydown', function(event) {
			if (event.key === 'Escape' && modal.classList.contains('active')) {
				closeDynamicFormModal();
			}
		});

		container.addEventListener('click', function(event) {
			if (event.target.closest('[data-modal-form-retry]') && activeFormKey) {
				var formKey = activeFormKey;
				loadModalForm(formKey).then(function(formPanel) {
					showFormPanel(formKey);
					focusForm(formPanel);
				}).catch(function() {});
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function() {
			initGatedContent();
			initDynamicFormModal();
		});
	} else {
		initGatedContent();
		initDynamicFormModal();
	}

	// rerun lazyload on screen size updates
	window.addEventListener( 'resize', function() {
		dbs.lazyload();
	});

	// Load event function ... most custom stuff goes here. Safer for async.
	window.addEventListener( 'load', function() {
		/* Search Form functionality
		 * The click functionality involves three different actions,
		 * depending on conditions the various clicks provide.
		 */
		var searchOpen = document.querySelectorAll( '.search-form__button--open' );
		var searchClose = document.querySelectorAll( '.search-form__button--close' );

		if ( searchOpen ) {
			for (var i=0; searchOpen.length > i; i++) {
				searchOpen[i].addEventListener( 'click', function() {
					this.parentElement.classList.add( 'search-form--active' );
					this.parentElement.querySelector('.site_search__field').focus();
		
					// Hide the search bar after click out of it
					document.getElementById( 'content' ).addEventListener( 'click', function() {
						if ( this.parentElement.classList.contains( 'search-form--active' ) ) {
							this.parentElement.classList.remove( 'search-form--active' );
						}
					});
				});
			}
			
			for (var i=0; searchClose.length > i; i++) {
				searchClose[i].addEventListener( 'click', function() {
					this.parentElement.classList.remove( 'search-form--active' );
				});
			}
		}


		/**
		 * Linkclicker
		 * 
		 * A class placed on a wrapping element with a link inside to make the wrapper clickable.
		 * Note: the container should have only one link.
		 */
		var linkclickers = document.querySelectorAll('.linkclicker');

		for ( var i = 0; linkclickers.length > i; i++ ) {
			var linkclicker = linkclickers[i];

			linkclicker.addEventListener('click', function(e) {
				e.preventDefault();
				var link = this.querySelector('a');
				var linkPath = link.getAttribute('href');
				
				if ( link.getAttribute('target', "_blank") ) {
					window.open(linkPath);
				} else {
					window.location.href = linkPath;
				}
			});
		}


		/**
		 * Force external links/PDFs to open in a new tab.
		 * From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
		 * 2019-07-11 - TA
		 */
		function link_is_external(link_element) {
			return ( link_element.host !== window.location.host || link_element.href.indexOf("pdf") > -1 );
		}

		var anchorElements = document.getElementsByTagName('a');
		for ( let anchorElement of anchorElements ) {

			if ( link_is_external( anchorElement ) ) {
				anchorElement.setAttribute( 'target','_blank' );
				anchorElement.setAttribute( 'rel','noopener' );

				// Add assistive text to alert of external links
				var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
				var assistiveTextContainer = document.createElement( 'span' );
				assistiveTextContainer.innerHTML = assistiveText;
				anchorElement.appendChild( assistiveTextContainer.firstChild );
			}
		}

        /**
		 * Captures Google Analytics Client ID and inputs into hidden form field
		 */
		var g_id = document.querySelector('.g-id input' );

		function fillClientId() {
			// Capture Client ID
			var clientId = document.cookie.match(/_ga=(.+?);/)[1].split('.').slice(-2).join(".");
			// Populate hidden form field with Client ID
			g_id.value = clientId;
		}

		// On pages with client ID form field and analytics is loaded, populate
		if ( g_id && Object.keys( window.google_tag_manager || [] ).filter( e => { return e.substring(0,2) == 'G-' } ).length > 0 ) {
			// Give GTM time to load
			setTimeout(function() {
				fillClientId();
			}, 5000);
		}

		/*
		 * Detects if element is in viewport and add class
		 */

		/**
         * Add class when the element's TOP is at least 20% from the bottom of the viewport.
         * (i.e., when el.getBoundingClientRect().top <= 0.8 * viewportHeight)
         */
        function observeElements(elements, className) {
        const observer = new IntersectionObserver((entries) => {
            const vh = window.innerHeight || document.documentElement.clientHeight;

            entries.forEach((entry) => {
            // Only consider elements within the viewport region (cheap guard)
            if (!entry.isIntersecting) return;

            const top = entry.target.getBoundingClientRect().top;

            if (top <= vh * 0.8) {
                entry.target.classList.add(className);
                observer.unobserve(entry.target); // optional: fire once
            }
            // else: still intersecting but top hasn't reached the 80% line yet.
            // Keep observing; the callback will fire again as it scrolls.
            });
        }, {
            root: null,
            // Trim the bottom 20% so we don't even get called until we're above that line.
            // (Helps reduce callback spam, but the top check above is the authoritative test.)
            rootMargin: '0px 0px -20% 0px',
            threshold: 0 // fire as soon as any pixel intersects the allowed area
        });

        elements.forEach(el => observer.observe(el));
}

// Usage
const elements = document.querySelectorAll('.animated');
observeElements(elements, 'in-view');


	
	/**
         * Collapsibles
         */
        var collapsibleHeaders = document.querySelectorAll(
            ".collapsible-row__header"
        );

        if (collapsibleHeaders) {
            for (var i = 0; collapsibleHeaders.length > i; i++) {
                var collapsibleHeader = collapsibleHeaders[i];

                collapsibleHeader.addEventListener("click", function () {
                    this.classList.toggle("expanded");
                    var textHeight = this.parentElement.nextElementSibling.querySelector(
                        ".collapsible-row__content"
                    ).clientHeight; // Get height of text within collapsible row
                    var rowHeight = this.parentElement.nextElementSibling.clientHeight; // Get height of row to see if it's expanded

                    if (rowHeight == 0) {
                        // If collapsible content is collapsed...
                        this.parentElement.nextElementSibling.style.height = textHeight + 1 + "px";
                    } else {
                        this.parentElement.nextElementSibling.style.height = 0 + "px";
                    }

                    if (this.parentNode.parentNode.classList.contains("expanded")) {
                        this.setAttribute("aria-expanded", "true");
                    } else {
                        this.setAttribute("aria-expanded", "false");
                    }
                });
                
                collapsibleHeader.parentElement.nextElementSibling.style.height = 0 + "px";
                collapsibleHeader.setAttribute("aria-expanded", "false");
            }
        }
        
        // Ensure Flickity has rendered
        const flickityEnabled = document.querySelectorAll('.flickity-enabled');
        if (flickityEnabled && flickityEnabled.length > 0) {            
            const flickities = Flickity.data(flickityEnabled);
            if (flickities && flickities.length > 0) {
                flickities.forEach(flkty => flkty.resize());
            }
        }

        // Re-run scroll if there’s a hash
        if (window.location.hash) {
            const target = document.querySelector(window.location.hash);
                if (target) {
                    const headerOffset = 96;
                    const elementPosition = target.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = elementPosition - headerOffset;
                    window.scrollTo({ top: offsetPosition });
                }
        }
        
        if (window.location.pathname.startsWith('/insights/')) {
            const content = document.querySelector('.blog-post__content');
            const layouts = content.querySelectorAll('.layout');
            
            layouts.forEach(layout => {
                layout.querySelectorAll('strong').forEach(strong => {
                    if (strong.textContent.includes('Myth:')) {
                        strong.style.color = '#697077';
                    } else if (strong.textContent.includes('Reality:')) {
                        strong.style.color = '#6F4C9E';
                    }
                });
            });
        }
    }); // End of load function
	

	// Include ready events here
	window.addEventListener( 'DOMContentLoaded', function() {
	});
    
    document.addEventListener('click', function (e) {
        const link = e.target.closest('a[href^="#"]');
        if (!link) return;

        const targetId = link.getAttribute('href');
        if (targetId.length <= 1) return; // ignore empty hashes or "#"

        const target = document.querySelector(targetId);
        if (!target) return;

        e.preventDefault();

        const headerOffset = 96; // example: 6rem if root font-size = 16px
        const elementPosition = target.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    });
    
    
    function onReady(fn) {
        if (document.readyState !== 'loading') {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }
        
    onReady(function () {
        let lastScrollY = window.scrollY;
        let ticking = false;
        const header = document.querySelector('.site-header');
        const headerHeight = header.offsetHeight;
        let hiddenOffset = 0; // how much of the header is currently hidden (0 = fully visible)

        function updateHeader() {
            const currentScrollY = window.scrollY;
            const delta = currentScrollY - lastScrollY;

            // Scrolling down → hide progressively
            if (delta > 0) {
                hiddenOffset = Math.min(hiddenOffset + delta, headerHeight);
            }
            // Scrolling up → reveal progressively
            else if (delta < 0) {
                hiddenOffset = Math.max(hiddenOffset + delta, 0);
            }

            // Apply transform to slide header based on hidden offset
            header.style.transform = `translateY(-${hiddenOffset}px)`;

            // Add/remove 'sticky' class based on scroll direction, position, and screen width
            const isDesktop = window.innerWidth >= 992;
            if (delta < 0 && currentScrollY > 0 && isDesktop) {
                header.classList.add('sticky');
            } else {
                header.classList.remove('sticky');
            }

            lastScrollY = currentScrollY;
            ticking = false;
        }

        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(updateHeader);
                ticking = true;
            }
        });
        
        // Also remove the class if resizing below desktop width
        window.addEventListener('resize', function() {
            const header = document.querySelector('.site-header');
            if (header && window.innerWidth < 992) {
                header.classList.remove('sticky');
            }
        });
    });
})();
